// ZŠ-specific data
export const ZS_BENEFITS = [
  {
    id: 1,
    title: "Úspora času 95%",
    description: "Tradiční způsob: desítky až stovky hodin práce. S Agent ŠVP: zlomek času.",
    stat: "95%",
    statLabel: "úspora času",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Soulad s RVP ZV 2025",
    description: "Kódy OVU, klíčové kompetence, průřezová témata i základní gramotnosti přebíráme 1:1 z oficiálního rámce.",
    stat: "100%",
    statLabel: "pokrytí RVP",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Zachování identity školy",
    description: "Agent ŠVP zachová vaše specifika — profil školy, tematické plány, projekty a tradice vaší ZŠ.",
    stat: "100%",
    statLabel: "vaše DNA",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Plná kontrola nad výsledkem",
    description: "Editujte, delegujte kapitoly na tým, kontrolujte soulad s RVP a exportujte do Wordu nebo PDF.",
    stat: "\u221e",
    statLabel: "možností",
    icon: "Settings"
  }
];

export const ZS_HOW_IT_WORKS_STEPS = [
  {
    step: 1,
    title: "Zaregistrujte školu",
    description: "Vytvořte si účet, zvolte tarif podle počtu žáků a pozvěte svůj tým — ředitele, koordinátora ŠVP i učitele.",
    details: ["Rychlá registrace", "Výběr tarifu dle počtu žáků", "Pozvání členů týmu"],
    icon: "Upload"
  },
  {
    step: 2,
    title: "Projděte průvodce",
    description: "13 krokový rozhovor o vaší škole. Agent ŠVP se vás zeptá na profil, zaměření a model výuky — předmětový, integrovaný nebo tematický.",
    details: ["13 kroků k profilu školy", "Výběr modelu výuky", "Zadání specifik vaší ZŠ"],
    icon: "Search"
  },
  {
    step: 3,
    title: "AI připraví návrh ŠVP",
    description: "Agent ŠVP vychází ze stávajícího ŠVP a profilu školy. Připraví nový návrh podle RVP ZV 2025 včetně školních výstupů, učiva a přehledných vazeb mezi kompetencemi, gramotnostmi a průřezovými tématy.",
    details: ["Starý ŠVP → nový návrh", "Školní výstupy a učivo", "Přehledné vazby podle RVP ZV 2025"],
    icon: "Sparkles"
  },
  {
    step: 4,
    title: "Sestavte učební plán",
    description: "Zadejte hodinové dotace a aplikace hlídá limity RVP, disponibilní časovou dotaci, povinné předměty i volitelné bloky.",
    details: ["Automatická kontrola limitů RVP", "DČD a povinné předměty", "Projekty a organizační formy"],
    icon: "CheckSquare"
  },
  {
    step: 5,
    title: "Upravte a delegujte",
    description: "Kontrolujte soulad na dashboardu, přidělujte kapitoly učitelům, upravujte texty a vazby. AI navrhne, vy potvrzujete.",
    details: ["Dashboard souladu s RVP", "Delegování na tým", "AI návrhy vazeb"],
    icon: "PenTool"
  },
  {
    step: 6,
    title: "Exportujte hotový ŠVP",
    description: "Stáhněte kompletní dokument jako Word nebo PDF — s prohlášením o souladu s RVP ZV 2025 a přehledovou maticí pokrytí.",
    details: ["Export do DOCX a PDF", "Prohlášení o souladu s RVP", "Matice pokrytí KK a PT"],
    icon: "Download"
  }
];

export const ZS_FEATURES = [
  {
    id: 1,
    title: "13 krokový průvodce tvorbou ŠVP",
    description: "Rozhovor o vaší škole — profil, zaměření, model výuky. Agent ŠVP navrhne celý ŠVP podle RVP ZV 2025.",
    icon: "Bot",
    highlight: true
  },
  {
    id: 2,
    title: "3 modely výuky",
    description: "Předmětový, integrovaný nebo tematický model. Zvolte si, jak chcete výuku organizovat — Agent ŠVP se přizpůsobí.",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Učební plán s kontrolou RVP",
    description: "Hodinové dotace s automatickou kontrolou limitů RVP, DČD, povinných předmětů a volitelných bloků.",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Provázanost OVU → ŠOVU → KK/PT/ZG",
    description: "Klikací tvorba vazeb mezi výstupy učení, kompetencemi, průřezovými tématy a gramotnostmi. 8 sloupcová tabulka NPI se vygeneruje sama.",
    icon: "Link"
  },
  {
    id: 5,
    title: "Základní gramotnosti",
    description: "Čtenářská, pisatelská a logicko-matematická gramotnost pro uzlové body 3., 5. a 9. ročníku s návrhem naplnění v předmětech.",
    icon: "BookOpen"
  },
  {
    id: 6,
    title: "Dashboard souladu s RVP",
    description: "Celkové procento souladu a detailní metriky. U každé nedokončené oblasti tlačítko Doplnit, které vás přesune přímo tam, kde je potřeba.",
    icon: "Target"
  },
  {
    id: 7,
    title: "Týmová spolupráce",
    description: "Ředitel, koordinátor, učitelé. Delegujte kapitoly a předměty, sledujte rozpracovanost. Automatické e-mailové notifikace.",
    icon: "Users"
  },
  {
    id: 8,
    title: "Export s prohlášením o souladu",
    description: "Word i PDF s prohlášením o souladu s RVP ZV 2025 a přehledovou maticí pokrytí kompetencí a průřezových témat.",
    icon: "FileText"
  }
];

export const ZS_FAQ_ITEMS = [
  {
    question: "Je Agent ŠVP opravdu v souladu s RVP ZV 2025?",
    answer: "Ano, kódy a znění očekávaných výsledků učení, klíčových kompetencí, průřezových témat i základních gramotností přebíráme 1:1 z oficiálního rámce NPI."
  },
  {
    question: "Jaké modely výuky Agent ŠVP podporuje?",
    answer: "Tři modely: předmětový (klasické samostatné předměty), integrovaný (spojení více oborů) a tematický (výuka v tematických blocích, vhodné pro 1. stupeň). Můžete je i kombinovat."
  },
  {
    question: "Mohu si výsledný dokument upravit?",
    answer: "Samozřejmě! Vše můžete editovat přímo v aplikaci a pak exportovat jako plně editovatelný Word dokument. Ve Wordu můžete provést jakékoliv další úpravy."
  },
  {
    question: "Jak funguje týmová spolupráce?",
    answer: "Ředitel má plný přístup, koordinátor ŠVP edituje všechny části a učitelé mají přístup jen k přiděleným kapitolám a předmětům. Přidělení spustí automatickou e-mailovou notifikaci."
  },
  {
    question: "Co je 8 sloupcová tabulka NPI?",
    answer: "Je to oficiální formát pro provázanost vzdělávacích výstupů. Agent ŠVP ji generuje automaticky — propojí OVU, ŠOVU, klíčové kompetence, průřezová témata a základní gramotnosti."
  },
  {
    question: "Jak funguje dashboard souladu?",
    answer: "Dashboard ukazuje celkové procento souladu s RVP ZV 2025 a detailní metriky u každé oblasti. U nedokončených částí je tlačítko Doplnit, které vás přesune přímo tam."
  },
  {
    question: "Jak funguje platba?",
    answer: "Cena je za jednu základní školu na rok. Po celou dobu máte plný přístup ke všem funkcím. Platba probíhá na základě faktury vystavené na vaši ZŠ, bankovním převodem."
  },
  {
    question: "Mám více základních škol. Jak to funguje?",
    answer: "Každá licence je pro jednu základní školu. Pokud spravujete více škol, kontaktujte nás na info@agentsvp.cz — rádi vám připravíme individuální nabídku."
  },
  {
    question: "Jak mě Agent ŠVP provede celým procesem?",
    answer: "Agent ŠVP obsahuje 13 krokového průvodce, kontextovou nápovědu a uživatelskou příručku. Vždy víte, co máte dělat dál — nikdy nezůstanete bez odpovědi."
  }
];

export const ZS_PRICING_TIERS = [
  { min: 1, max: 50, price: "14 990", label: "1–50 žáků" },
  { min: 51, max: 100, price: "17 990", label: "51–100 žáků" },
  { min: 101, max: 150, price: "20 990", label: "101–150 žáků" },
  { min: 151, max: 200, price: "23 990", label: "151–200 žáků" },
  { min: 201, max: 250, price: "26 990", label: "201–250 žáků" },
  { min: 251, max: 300, price: "29 990", label: "251–300 žáků" },
  { min: 301, max: 400, price: "34 990", label: "301–400 žáků" },
  { min: 401, max: 500, price: "39 990", label: "401–500 žáků" },
  { min: 501, max: 650, price: "44 990", label: "501–650 žáků" },
  { min: 651, max: 9999, price: null, label: "Více než 650 žáků" }
];

export const ZS_PRICING_FEATURES = [
  "Vytvoření kompletního ŠVP v souladu s RVP ZV 2025 pomocí AI agenta",
  "13 krokový průvodce tvorbou ŠVP",
  "3 modely výuky — předmětový, integrovaný, tematický",
  "Provázanost OVU → ŠOVU → KK/PT/ZG",
  "Učební plán s kontrolou limitů RVP",
  "Kurikulární audit a simulace auditu ČŠI",
  "Týmová spolupráce — ředitel, koordinátor, učitelé",
  "Export do DOCX a PDF s prohlášením o souladu",
  "Automatické ukládání a historie verzí",
  "Celý rok můžete ŠVP ladit a upravovat"
];

export const ZS_RVP_COMPLIANCE = {
  areas: [
    "Jazyk a jazyková komunikace",
    "Matematika a její aplikace",
    "Informatika",
    "Člověk a jeho svět",
    "Člověk a společnost",
    "Člověk a příroda",
    "Umění a kultura",
    "Člověk a zdraví",
    "Člověk a svět práce"
  ],
  competencies: [
    "K učení",
    "Komunikační",
    "K řešení problémů",
    "Osobnostní a sociální",
    "K občanství a udržitelnosti",
    "K podnikavosti a pracovní",
    "Kulturní",
    "Digitální"
  ],
  literacies: ["Čtenářská gramotnost", "Pisatelská gramotnost", "Logicko-matematická gramotnost"],
  themes: ["Péče o sebe a druhé", "Společnost pro všechny", "Udržitelné prostředí"],
  chapters: [
    "Identifikační údaje",
    "Charakteristika školy",
    "Charakteristika ŠVP",
    "Učební plán",
    "Učební osnovy",
    "Hodnocení výsledků vzdělávání",
    "Podmínky vzdělávání",
    "Evaluační systém"
  ]
};
